<template>

<app-page>

	<core-filter-bar v-if="!is.loading && is.initialised">

		<core-filter-bar-left>

			<core-filter-summary title="Early Access" icon="flask" />

		</core-filter-bar-left>

	</core-filter-bar>

	<core-content-page>

		<core-content-wrapper :loading="is.loading && !is.initialised">

			<div class="items" :class="{'is-hidden': is.loading && !is.initialised}">

				<div class="item is-intro" key="intro">

					<div class="item-text">

						<p>Try out new GeekGroup features before they’re released to everyone. It's your chance to get exclusive access to explore new featres, preview what’s coming next, and help shape how features evolve.</p>

						<p>Some will be major new features, others will be small experimental ideas. You can opt in to what interests you and opt out anytime too.</p>

						<p>Thanks for supporting GeekGroup and being part of what’s next!</p>
						
					</div>

				</div>

				<div class="item" v-for="item in data.items" :key="item.id">

					<div class="item-image" v-bgimage="item.image" v-if="item.status === 1" />

					<div class="item-coming" v-if="item.status === 2">

						{{ item.url | 'Coming soon' }}	

					</div>

					<div class="item-text">

						<h2>{{ item.name }}</h2>

						<div class="item-date" v-if="item.status === 1">Until {{ item.date.live | formatDate('Do MMMM YYYY') }}</div>

						<p v-html="item.description" />

						<template v-if="item.status === 1">

							<core-button text="Enable" :loading="is.toggling === item.id" class="item-button" v-on:click="onItemClick(item.id)" v-if="!hasAccess(item.slug)" />
							<core-button text="Disable" :loading="is.toggling === item.id" theme="red" class="item-button" v-on:click="onItemClick(item.id)" v-if="hasAccess(item.slug)" />

						</template>

						<core-button text="Read more" class="item-button is-more" v-if="item.status === 1" />

					</div>

				</div>

			</div>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {
	
		return {

			data: {},

			is: {
				initialised: false,
				loading: true,
				toggling: false
			}

		}
	
	},

	created: function() {

		this.load()

	},

	methods: {
	
		load: function() {
		
			this.$api.get('session/early').then(function(json) {

				Vue.set(this, 'data', json)

				this.is.initialised = true

				this.is.loading = false
			
			}.bind(this))
		
		},

		onMoreClick: function(url) {

			window.open(url)

		},

		onItemClick: function(id) {

			this.is.toggling = id

			this.$api.post('session/early', {
				id: id
			}).then(function(json) {

				this.$store.commit('session/early', json.early)

				this.is.toggling = false
			
			}.bind(this))

		},

		hasAccess: function(slug) {

			return this.$_.contains(this.$store.getters['session/early'] || [], slug)

		}

	}

}

</script>

<style scoped>

.items {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto;
	grid-gap: 40px;
    align-items: start;
}

.is-smaller .items {
	grid-gap: 20px;
}

.is-tablet .items {
	grid-gap: 20px;
	grid-template-columns: 1fr 1fr;
}

.is-mobile .items {
	grid-template-columns: 1fr;
	grid-gap: 20px;
	padding: 20px;
}

.items.is-hidden {
	opacity: 0;
}

.item-image {
	height: 180px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
	border: 1px solid #ddd;
    background-size: cover;
}

.item-coming {
	height: 160px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
	border: 1px solid #ddd;
    background-size: cover;
	text-align: center;
	line-height: 160px;
	font-size: 32px;
	font-weight: 500;
	color: #fff;
}

.item-text {
	padding: 20px;
	border: 1px solid #ddd;
	border-top: 0px;
	background-color: #fff;
	border-radius: 0px 0px 4px 4px;
}

.item.is-intro .item-text {
	border-top: 1px solid #ddd;
	border-radius: 4px;
	height: 100%;
}

.item-text h2 {
	font-size: 20px;
	margin-bottom: 4px;
}

.item.is-intro .item-text h2 {
	margin-bottom: 20px;
}

.item-text p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 20px;
}

.item-text p:last-child {
	margin-bottom: 0px;
}

.item-date {
	font-size: 14px;
	line-height: 14px;
	font-weight: 400;
	color: #999;
	margin-bottom: 10px;
}

.item-button {
	width: 100%;
}

.item-button.is-more {
	margin-top: 5px;
}

</style>